'use strict';
const CiscoWebexScriptLoader = require('../../models/cisco-webex-script-loader'),
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	uniqueString = require('@mindmup/js-utils/src/unique-string'),
	CiscoWebexShim = function ({ciscoWebexScriptLoader}) {
		let app = false,
			forceInit;

		const dispatcher = observable(this),
			forceInitPromise = new Promise((resolve) => {forceInit = resolve;}),
			init = async () => {
				if (!app) {
					const container = await ciscoWebexScriptLoader.ensureScripts();
					app = new container.Webex.Application();
					await app.listen();
					app.on('application:shareStateChanged', (isShared) => {
						dispatcher.dispatchEvent('shareStateChanged', isShared);
					});
					app.on('space:infoChanged', (evt) => {
						dispatcher.dispatchEvent('spaceInfoChanged', evt);
					});
				}
				await Promise.race([forceInitPromise, app.onReady()]);
			},
			getCiscoUser = async () => {
				if (!app) {
					throw new Error('init not completed');
				}
				return app.context.getUser();

			},
			getCiscoDisplayContext = async () => {
				if (!app) {
					throw new Error('init not completed');
				}
				if (/^MEETING/.test(app.displayContext)) {
					const meeting = await app.context.getMeeting();
					return `meeting:${meeting.id}`;
				} else if (/^SPACE/.test(app.displayContext)) {
					const space = await app.context.getSpace();
					console.log(JSON.stringify({space}));
					return `space:${space.id}`;
				} else {
					throw new Error('invalid app context: ' + app.displayContext);
				}
			},
			setShareUrl = (url, mapConfig) => app.setShareUrl(url, '', mapConfig.mapTitle),
			clearShareUrl = () => app && app.clearShareUrl(),
			isAppShared = () => app?.isShared;

		Object.freeze(Object.assign(this, {init, setShareUrl, forceInit, getCiscoUser, isAppShared, clearShareUrl, getCiscoDisplayContext}));
	},
	CiscoWebexPageController = function({ciscoWebexShim, authenticationModel} = {}) {
		if (!ciscoWebexShim || !authenticationModel) {
			throw new Error('invalid args');
		}
		let mapTitle = 'New MindMup Map',
			mapTheme = false,
			mapPassword = uniqueString(),
			timeLimitHours = 24 * 365,
			accessLevel = 'collaborator',
			selectedFile = false;

		const dispatcher = observable(this),
			sendContext = (message) => {
				const context = {
					fileSelected: !!selectedFile
				};
				dispatcher.dispatchEvent('context', Object.assign({message}, context));
			},
			showProgressMessage = (message) => sendContext(message),
			errorReason = reason => {
				dispatcher.dispatchEvent('error', reason);
			},
			setMapTheme = (newTheme) => {mapTheme = newTheme;},
			setMapAccessLevel = (newAccessLevel) => {accessLevel = newAccessLevel;},
			setMapTitle = (newTitle) => {mapTitle = newTitle;},
			setMapTimeLimitHours = (newTimelimitHours) => {timeLimitHours = newTimelimitHours;},
			setMapPassword = (newPassword) => {mapPassword = newPassword;},
			setSelectedFile = (newFile) => {
				selectedFile = newFile;
				sendContext();
			},
			getMapConfig = () => {
				if (selectedFile) {
					const selectedFileUrl = selectedFile?.url,
						selectedFileId = selectedFileUrl && selectedFileUrl.split('/')[1];
					return {mapTitle: selectedFile.description, password: mapPassword, timeLimitHours, accessLevel, selectedFileId};
				} else {
					return {mapTheme, mapTitle, password: mapPassword, timeLimitHours, accessLevel};
				}
			},
			ready = async () => {
				await ciscoWebexShim.init();
				const user = await ciscoWebexShim.getCiscoUser();
				if (user?.email) {
					authenticationModel.setSuggestedEmail(user.email);
				}
			};
		Object.freeze(Object.assign(this, {setMapTheme, setMapTitle, getMapConfig, setMapPassword, setMapTimeLimitHours, setMapAccessLevel, showProgressMessage, errorReason, setSelectedFile, ready}));
	},
	CiscoWebexSharingModel = function ({ciscoWebexShim, ciscoWebexPageController, authenticationModel, goldApi, s3FileModel, defaultMapContent, navigatorShim}) {
		if (!ciscoWebexShim || !ciscoWebexPageController || !s3FileModel || !defaultMapContent ||  !authenticationModel || !goldApi) {
			throw new Error('invalid-args');
		}
		const generateMapContent = (mapTitle, mapTheme) => {
				const mapContent = JSON.parse(JSON.stringify(defaultMapContent));
				if (mapTitle) {
					mapContent.ideas[1].title = mapTitle;
				}
				if (mapTheme) {
					mapContent.attr = {theme: mapTheme};
				}
				return JSON.stringify(mapContent);
			},
			getLicense = async () => {
				const license = await authenticationModel.getLicense();
				if (!license) {
					throw 'not-authenticated';
				}
				return license;
			},
			createPublicUrl = async ({fileKey, accessLevel, token}) => {
				const license = await getLicense(),
					params = {
						license,
						fileKey,
						accessLevel,
						externalContextId: token
					};
				return goldApi.exec('file/cisco/create', params);
			},
			createNewMap = async (mapTitle, mapTheme) => {
				ciscoWebexPageController.showProgressMessage('Creating new map, please wait...');
				return s3FileModel.createFile(mapTitle, null, generateMapContent(mapTitle, mapTheme));
			},
			createCiscoShareUrl = async (fileId, mapConfig) => {
				ciscoWebexPageController.showProgressMessage('Sharing map, please wait...');
				const user = await ciscoWebexShim.getCiscoUser(),
					crowdLinkUrl =  await createPublicUrl(Object.assign({fileKey: `${fileId}.pointer`, token: user.token}, mapConfig));
				return `${crowdLinkUrl.url}#editingContext=compact`;
			},
			setShareUrl = async (sharedUrl, mapConfig) => {
				ciscoWebexPageController.showProgressMessage('Sharing map, please wait...');
				return ciscoWebexShim.setShareUrl(sharedUrl, mapConfig);
			},
			shareNewMap = async () => {
				ciscoWebexPageController.setSelectedFile(false);
				const mapConfig = ciscoWebexPageController.getMapConfig(),
					savedFileInfo = await createNewMap(mapConfig.mapTitle, mapConfig.mapTheme),
					sharedUrl = await createCiscoShareUrl(savedFileInfo.savedFileId, mapConfig);
				await setShareUrl(sharedUrl, mapConfig);
				navigatorShim.redirect(sharedUrl);
			},
			shareSelectedMap = async () => {
				const mapConfig = ciscoWebexPageController.getMapConfig(),
					sharedUrl = mapConfig.selectedFileId && await createCiscoShareUrl(mapConfig.selectedFileId, mapConfig);
				if (sharedUrl) {
					await setShareUrl(sharedUrl, mapConfig);
					navigatorShim.redirect(sharedUrl);
				} else {
					ciscoWebexPageController.errorReason('no file is selected');
				}
			};
		Object.freeze(Object.assign(this, {shareNewMap, shareSelectedMap}));
	};
module.exports = function ciscoWebexStart({config, navigatorShim, ciscoWebexContainer, s3FileModel, defaultMapContent,  authenticationModel, goldApi} = {}) {
	if (!config || !navigatorShim || !ciscoWebexContainer || !s3FileModel || !defaultMapContent  ||  !authenticationModel || !goldApi) {
		throw new Error('invalid-args');
	}
	const ciscoWebexScriptLoader = new CiscoWebexScriptLoader({config, navigatorShim, ciscoWebexContainer}),
		ciscoWebexShim = new CiscoWebexShim({ciscoWebexScriptLoader}),
		ciscoWebexPageController = new CiscoWebexPageController({ciscoWebexShim, authenticationModel}),
		ciscoWebexSharingModel = new CiscoWebexSharingModel({ciscoWebexPageController, ciscoWebexShim,  authenticationModel, goldApi, s3FileModel, defaultMapContent, navigatorShim});

	return {ciscoWebexSharingModel, ciscoWebexPageController, ciscoWebexShim};
};

